import i18n from "./index";

// Vain sovelluksen omat näyttönimet ja ilmoitukset. Tallennettavia arvoja ei muuteta.
// Tuntematon viesti näytetään sellaisenaan; älä käytä tätä esiintyjän omiin teksteihin.
const labelKeys = {
  "Sulje info": "text001",
  "Poista keikkaraportti": "text002",
  "Poistetaanko tallennettu keikkaraportti?": "text003",
  "Sulje": "text004",
  "Tallennettu keikkaraportti poistetaan pysyvästi.": "text005",
  "Biisitoiveet, settilistat ja Keikkamuisti säilyvät ennallaan.": "text006",
  "Peruuta": "text007",
  "Aloita uusi keikka": "text008",
  "Nollataanko nykyinen keikkatilanne?": "text009",
  "Tämä poistaa nykyiset biisitoiveet, sulkee aktiivisen settilistan, nollaa arvonnan ja aloittaa uuden keikan tilastot nollasta.": "text010",
  "Jos haluat säilyttää nykyisen keikan statsit, tallenna keikkaraportti ennen uuden keikan aloittamista.": "text011",
  "Tallennetut keikkaraportit, biisikirjasto ja Keikkamuisti säilyvät.": "text012",
  "Muokkaa biisiä": "text013",
  "Muutos tallennetaan biisikirjastoon ja päivittyy tähän lukutilaan.": "text014",
  "Sanat ja soinnut / ChordPro": "text015",
  "Kirjoita tai korjaa sanat ja soinnut tähän.": "text016",
  "Spiikki / muistiinpano": "text017",
  "Sulje spiikki": "text018",
  "Hidasta prompteria": "text019",
  "Nopeuta prompteria": "text020",
  "Palaa alkuun": "text021",
  "Palauta työkalut": "text022",
  "Edellinen biisi": "text023",
  "Soitettu": "text024",
  "Soitettu + seuraava": "text025",
  "✓ Soitettu": "text026",
  "Ei soitettu": "text027",
  "Ei soitettu + seuraava": "text028",
  "× Ei soit.": "text029",
  "Seuraava biisi": "text030",
  ". biisi": "text031",
  "Spiikki": "text032",
  "Näytä": "text033",
  "Sulje lukutila": "text034",
  "Sanat ja soinnut": "text035",
  "Sanoja ja sointuja ei ole vielä lisätty": "text036",
  "Tämä biisi avautuu silti lukutilaan normaalisti. Voit lisätä sanat, soinnut tai ChordPro-tekstin painamalla Muokkaa ja kirjoittamalla tai liittämällä tekstin biisille.": "text037",
  "Lisää sanat / soinnut": "text038",
  "Lukutila": "text039",
  "Alkuun": "text040",
  "Muokkaa": "text041",
  "Tyhjennä merkintä": "text042",
  "Pienennä tekstikokoa": "text043",
  "A−": "text044",
  "px": "text045",
  "Suurenna tekstikokoa": "text046",
  "A+": "text047",
  "Nopeus": "text048",
  "← Edellinen": "text049",
  "Seuraava →": "text050",
  "Esiintyjä": "text051",
  "Biisikirjasto": "text052",
  "Paranoidi hallinta": "text053",
  "Hallinta": "text054",
  "Uusia:": "text055",
  "Yhteensä:": "text056",
  "Yleisölle näkyvä kieli": "text057",
  "Kaikki kielet": "text058",
  "Suomi": "text059",
  "Englanti": "text060",
  "Ruotsi": "text061",
  "Saksa": "text062",
  "Espanja": "text063",
  "Italia": "text064",
  "Viro": "text065",
  "Norja": "text066",
  "Tanska": "text067",
  "Muu kieli": "text068",
  "Arvo palkinnon voittaja": "text069",
  "Siivoa soitetut toiveet": "text070",
  "Toivearvonnan voittaja": "text071",
  "Osallistui arvontaan": "text072",
  "toiveella.": "text073",
  "Toive:": "text074",
  "Toivehallinta": "text075",
  "Tapahtumat": "text076",
  "Keikkatyökalu": "text077",
  "Keikkamuisti": "text078",
  "Yhteenveto": "text079",
  "Tilauksesi ei kata tätä osiota": "text080",
  "Keikkatyökalu kuuluu Plus-pakettiin. Sen avulla voit luoda settilistoja, käyttää lukutilaa, vaihtaa biisejä lennossa ja käyttää Keikkarandomia tilaisuustägien perusteella.": "text081",
  "Katso Plus-paketti": "text082",
  "Keikkamuisti · Plus": "text083",
  "Välispiikit ja muistiinpanot samaan paikkaan.": "text084",
  "Keikkamuisti kuuluu Plus-pakettiin. Sinne voit tallentaa välispiikkejä, muistettavia asioita, keikan rakenteita ja nopeita huomioita esiintymistä varten.": "text085",
  "Live-yhteenveto": "text086",
  "Tämänhetkinen keikkatilanne: biisitoiveet, aktiivinen settilista, soitettu/ei soitettu -merkinnät ja biiseihin liitetyt Keikkamuistin muistiinpanot.": "text087",
  "Nykyinen keikka": "text088",
  "Tilastot alkaen": "text089",
  "Keikan aloitusaikaa ei ole tallennettu. Se tallentuu seuraavan kerran, kun painat": "text090",
  "Settilista:": "text091",
  "Tilaisuus:": "text092",
  "Kopioi yhteenveto": "text093",
  "Tallennetut raportit": "text094",
  "Tallennettu": "text095",
  "Poista": "text096",
  "Suosituimmat": "text097",
  "Suosituimmat biisitoiveet": "text098",
  "Ei biisitoiveita vielä.": "text099",
  "Soitetut": "text100",
  "Soitetut biisit": "text101",
  "Ei soitetuksi merkittyjä biisejä vielä.": "text102",
  "Erikoistoiveet": "text103",
  "Vapaat biisitoiveet": "text104",
  "Ei vapaita biisitoiveita vielä.": "text105",
  "Yleisö": "text106",
  "Aktiivisimmat nimet / pöydät / porukat": "text107",
  "Ei nimiä, pöytiä tai porukoita vielä.": "text108",
  "Kopioitava teksti": "text109",
  "Keikkaraportti": "text110",
  "Settilistat ja lukutila": "text111",
  "Luo tai lataa settilista nykyiselle keikalle, muokkaa sitä tarpeen mukaan ja avaa biisit keikan aikana lukutilaan. Tarkemmat käyttöohjeet löydät sivun": "text112",
  "OHJE": "text113",
  "-painikkeesta.": "text114",
  "Settilistan nimi": "text115",
  "Esim. Hääkeikka Nurmijärvi 22.6. tai Pubisetti 1": "text116",
  "Nimi näkyy tallennetuissa seteissä. Voit muuttaa sitä myöhemmin ja painaa tallenna setti.": "text117",
  "Luo settilista": "text118",
  "Perusvalinnat": "text119",
  "Valitse tilaisuus, kieli ja setin koko. Tarkemmat tilaajan rajaukset ovat lisäasetuksissa.": "text120",
  "biisistä puuttuu kieli": "text121",
  "Kieli puuttuu -biisit ovat mukana": "text122",
  "-valinnassa, mutta eivät tule mukaan, jos rajaat settilistan esimerkiksi vain suomen- tai englanninkielisiin.": "text123",
  "Tilaisuus": "text124",
  "Kieli": "text125",
  "Settejä": "text126",
  "Biisejä per setti": "text127",
  "Tilaajan rajaukset ja toiveet": "text128",
  "Vältä artisteja": "text129",
  "Näytä vältettävien artistien ohje": "text130",
  "i": "text131",
  "Esim. Queen, Eppu Normaali": "text132",
  "Vältä genrejä / tyylejä": "text133",
  "Näytä vältettävien genrejen ja tyylien ohje": "text134",
  "Esim. hevi, rap, iskelmä": "text135",
  "Luo tyhjä settilista": "text136",
  "Sulje setti": "text137",
  "✓ Muutokset tallennettu.": "text138",
  "⚠ Tallentamattomia muutoksia — paina": "text139",
  "ylhäältä.": "text140",
  "Lisätoiminnot": "text141",
  "Kopioi settilista": "text142",
  "Tulosta / PDF": "text143",
  "Lähetä sähköpostilla": "text144",
  "Tallennetut setit": "text145",
  "Lataa": "text146",
  "Poista setti": "text147",
  "Ei biisejä vielä. Hae biisi alta omasta biisikirjastosta ja lisää se tähän settiin.": "text148",
  "Avaa lukutila": "text149",
  "Vaihda biisi": "text150",
  "Vaihda": "text151",
  "Siirrä biisi ylöspäin": "text152",
  "Ylös": "text153",
  "Siirrä biisi alaspäin": "text154",
  "Alas": "text155",
  "Poista biisi tästä setistä": "text156",
  "Poista setistä": "text157",
  "Lisää tallennetusta Keikkamuistista": "text158",
  "Spiikki / muistiinpano tämän biisin jälkeen": "text159",
  "Esim. Kiitä yleisöä ja pyydä seuraavaa biisitoivetta QR-koodilla.": "text160",
  "Linkitetty Keikkamuisti": "text161",
  "Sama Keikkamuisti": "text162",
  "Irrota biisistä": "text163",
  "Päivitä Keikkamuisti": "text164",
  "Poista muistiinpano": "text165",
  "Lisää biisi tähän settiin": "text166",
  "Hae biisiä tai artistia..": "text167",
  "Lisää": "text168",
  "Ei osumia biisikirjastosta.": "text169",
  "Maksettu näkyvyysnosto": "text170",
  "Nostetut toiveet": "text171",
  "Nämä aktiiviset toiveet on nostettu näkyvästi muiden toiveiden edelle.": "text172",
  "Nostettu toive": "text173",
  "Vapaa toive": "text174",
  "Tapahtuma ·": "text175",
  "Nostettu": "text176",
  "Merkitse soitetuksi": "text177",
  "Toteutumattomat unelmat": "text178",
  "Nämä ovat biisejä, joita yleisö toivoi, mutta joita ei löytynyt esiintyjän ohjelmistosta.": "text179",
  "Toivottu": "text180",
  "kertaa": "text181",
  "Mukana arvonnassa": "text182",
  "Ei uusia biisitoiveita vielä": "text183",
  "Kun yleisö lähettää biisitoiveita, ne ilmestyvät tähän. Jaa yleisölinkki keikalla tai näytä QR-koodi Asetuksista.": "text184",
  "Avaa yleisösivu": "text185",
  "Avaa asetukset ja QR-koodi": "text186",
  "Soitetut toiveet": "text187",
  "Piilota": "text188",
  "Arvontaa ei voi suorittaa": "text189",
  "Arvonta": "text190",
  "Arvontaa ei voi tehdä vielä": "text191",
  "Sulje arvontailmoitus": "text192",
  "Toiveen lähettäjän pitää kirjoittaa nimi, nimimerkki, pöytä tai porukka, jotta hän voi olla mukana palkintoarvonnassa.": "text193",
  "Selvä": "text194",
  "Siivoa soitetut toivebiisit": "text195",
  "Vahvista siivous": "text196",
  "Poistetaanko soitetut toivebiisit?": "text197",
  "Sulje vahvistus": "text198",
  "Tämä poistaa listalta vain soitetuksi merkityt toivebiisit. Uudet ja nähdyt toiveet jäävät jonoon. Toimintoa ei voi perua.": "text199",
  "Kyllä, poista soitetut": "text200",
  "Poistetaan...": "text201",
  "Poista raportti": "text202",
  "Aloitetaan...": "text203",
  "Tallennetaan...": "text204",
  "Tallenna biisi": "text205",
  "Stop": "text206",
  "Prompteri": "text207",
  "LIVE · Toivekanava auki": "text208",
  "OFFLINE · Toivekanava kiinni": "text209",
  "Nimetön settilista": "text210",
  "Ei aktiivista settilistaa": "text211",
  "Tallenna keikkaraportti": "text212",
  "Biisitoiveita": "text213",
  "Nykyisellä toivelistalla olevat toiveet.": "text214",
  "Eri biisejä": "text215",
  "Kuinka montaa eri kappaletta on toivottu.": "text216",
  "Soitetuksi merkitty": "text217",
  "Toiveet, jotka olet merkinnyt soitetuksi.": "text218",
  "Käsittelemättä": "text219",
  "Toiveet, joita ei ole vielä merkitty soitetuksi.": "text220",
  "Vapaita toiveita": "text221",
  "Yleisön tai esiintyjän vapaasti kirjoittamat erikoistoiveet.": "text222",
  "Nostettuja toiveita": "text223",
  "Maksetulla näkyvyysnostolla nostetut biisitoiveet.": "text224",
  "Nostoista maksettu": "text225",
  "Keikan aikana näkyvyysnostoista maksettu summa.": "text226",
  "Settilistan biisit": "text227",
  "Aktiiviseksi ladatun settilistan biisit.": "text228",
  "Soitetut setistä": "text229",
  "Settilistasta soitetuksi merkityt biisit.": "text230",
  "Skipatut tai keikalla pois jätetyt biisit.": "text231",
  "Merkitsemättä": "text232",
  "Settilistan biisit, joita ei ole vielä merkitty.": "text233",
  "Muistiinpanot": "text234",
  "Settilistan biiseihin liitetyt spiikit ja muistiinpanot.": "text235",
  "Hallitse biisejä, tageja, sanoja ja sointuja": "text236",
  "Hallitse biisejä ja tageja": "text237",
  "Täällä lisäät ja muokkaat biisejä. Biisikirjastossa määritetään myös artisti, genre, vuosikymmen, kieli, tilaisuustagit sekä sanat ja soinnut. Näitä tietoja käytetään julkisessa biisitoivekanavassa ja settilistojen luonnissa.": "text238",
  "Täällä lisäät ja muokkaat biisejä. Biisikirjastossa määritetään myös artisti, genre, vuosikymmen, kieli ja tilaisuustagit. Näitä tietoja käytetään julkisessa biisitoivekanavassa.": "text239",
  "Luo uusi settilista": "text240",
  "Sekoita uudelleen": "text241",
  "Tallenna muutokset": "text242",
  "Tallenna setti": "text243",
  "Valitse välispiikki tai muistiinpano...": "text244",
  "Ei tallennettuja keikkamuistiinpanoja": "text245",
  " (liitetty)": "text246",
  "nostettu toive": "text247",
  "nostettua toivetta": "text248",
  "toive": "text249",
  "toivetta": "text250",
  "Palauta nähdyksi": "text251",
  "Palauta uudeksi": "text252",
  "Seuraa yleisön biisitoiveita, hallitse toivekanavaa ja pidä keikan toivetilanne järjestyksessä.": "text253",
  "Lisää ja hallitse tulevia keikkoja ja tapahtumia, jotka näkyvät esiintyjän Paranoidi-sivulla.": "text254",
  "Ylläpidä ohjelmistoasi, biisien tietoja, näkyvyyttä sekä sanoja ja sointuja.": "text255",
  "Ylläpidä ohjelmistoasi, biisien tietoja ja näkyvyyttä.": "text256",
  "Rakenna ja hallitse settilistoja, lisää keikkamuistiinpanoja ja avaa lukutila keikkaa varten.": "text257",
  "Tallenna välispiikit, muistutukset ja muut keikalla tarvittavat muistiinpanot.": "text258",
  "Seuraa nykyisen keikan tilannetta ja tärkeimpiä tietoja yhdestä näkymästä.": "text259",
  "Nähty": "text260",
  "Uusi": "text261",
  "Nähdyt toiveet": "text262",
  "Uudet toiveet": "text263",
  "Tumma": "text264",
  "Vaalea": "text265",
  "Kontrasti": "text266",
  "Ranska": "text267",
  "Muu": "text268",
  "Tuntematon": "text269",
  "Kieli puuttuu": "text270",
  "Toivearvonta ei ole käytössä. Ota se tarvittaessa käyttöön Asetuksista.": "text271",
  "Arvonta on jo suoritettu tälle toivelistalle. Siivoa soitetut toiveet aloittaaksesi uuden setin.": "text272",
  "Palkinnon valintaan tarvitaan vähintään yksi biisitoive, jossa osallistuja on valinnut olevansa mukana arvonnassa.": "text273",
  "Valitse ensin tilaisuus.": "text274",
  "Uutta settilistaa ei voitu aloittaa.": "text275",
  "Tyhjä settilista luotu. Hae biisi setin alta omasta biisikirjastosta ja lisää se tähän settiin.": "text276",
  "Tyhjää settilistaa ei voitu aloittaa.": "text277",
  "Toivottavia biisejä ei löytynyt.": "text278",
  "Tämä Keikkamuisti on jo liitetty tähän biisiin.": "text279",
  "Keikkamuisti liitetty biisiin.": "text280",
  "Keikkamuisti irrotettu biisistä.": "text281",
  "Biisikohtainen muistiinpano poistettu.": "text282",
  "Luo ensin settilista.": "text283",
  "Settilista kopioitu leikepöydälle.": "text284",
  "Kopiointi epäonnistui. Voit maalata settilistan ja kopioida sen käsin.": "text285",
  "Tulostusikkunan avaaminen epäonnistui. Salli ponnahdusikkunat selaimessa.": "text286",
  "Tulostus avattu. Valitse tarvittaessa Tallenna PDF:nä.": "text287",
  "Sähköpostiluonnos avattu.": "text288",
  "Esiintyjän tunniste puuttuu. Kirjaudu ulos ja takaisin sisään.": "text289",
  "Tallennettu settilista päivitetty ja asetettu aktiiviseksi.": "text290",
  "Settilista tallennettu palvelimelle ja asetettu aktiiviseksi.": "text291",
  "Settilistan tallennus epäonnistui.": "text292",
  "Tallennettu settilista ladattu ja asetettu nykyisen keikan aktiiviseksi settilistaksi.": "text293",
  "Settilistaa ei voitu asettaa aktiiviseksi.": "text294",
  "Nykyisen keikan aktiivinen settilista palautettiin automaattisesti.": "text295",
  "Setti suljettu. Voit nyt luoda uuden settilistan.": "text296",
  "Settiä ei voitu sulkea.": "text297",
  "Settilista poistettiin, mutta aktiivisen settilistan tiedon tyhjennys asetuksista epäonnistui.": "text298",
  "Aktiivinen settilista poistettu ja nykyisen keikan settilista tyhjennetty.": "text299",
  "Tallennettu settilista poistettu palvelimelta.": "text300",
  "Settilistan poisto epäonnistui.": "text301",
  "Biisiä ei löytynyt biisikirjastosta.": "text302",
  "Settilistassa pitää olla vähintään yksi setti.": "text303",
  "Lisää vähintään yksi biisirivi.": "text304",
  "Biisien tallennus epäonnistui.": "text305",
  "Live-yhteenveto kopioitu leikepöydälle.": "text306",
  "Kopiointi epäonnistui. Voit maalata tekstin ja kopioida sen käsin.": "text307",
  "Raporttia ei tallennettu, koska biisitoiveita, settilistaa tai keikkamuistia ei ole vielä.": "text308",
  "Keikkaraportti tallennettu.": "text309",
  "Keikkaraportin tallennus epäonnistui.": "text310",
  "Raportin poisto ei onnistu. Raportti puuttuu.": "text311",
  "Raportin poisto ei onnistu. Esiintyjä tai raportti puuttuu.": "text312",
  "Keikkaraportti poistettu. Nykyinen keikkatilanne säilyi ennallaan.": "text313",
  "Keikkaraportin poisto epäonnistui.": "text314",
  "Uuden keikan aloitus epäonnistui.": "text315",
  "Biisi merkitty soitetuksi. Muista tallentaa setti, jos haluat merkinnän säilyvän setissä.": "text316",
  "Biisi merkitty ei soitetuksi. Muista tallentaa setti, jos haluat merkinnän säilyvän setissä.": "text317",
  "Biisin keikkamerkintä tyhjennetty.": "text318",
  "Biisin tallennus ei onnistu. Esiintyjä tai biisi puuttuu.": "text319",
  "Biisi tallennettu.": "text320",
  "Biisin sanat ja soinnut päivitetty.": "text321",
  "Biisin tallennus epäonnistui.": "text322",
  "Pysäytä prompteri": "text323",
  "Käynnistä prompteri": "text324",
  "Piilota soinnut": "text325",
  "Näytä soinnut": "text326",
  "Tasaa vasempaan reunaan": "text327",
  "Keskitä teksti": "text328",
  "Näytä työkalut": "text329",
  "Piilota työkalut": "text330",
  "After ski": "text331",
  "Baarikeikka": "text332",
  "Brunssi": "text333",
  "Festivaali": "text334",
  "Häät": "text335",
  "Iltamat": "text336",
  "Jatkot": "text337",
  "Joulukeikka": "text338",
  "Klubi": "text339",
  "Laiva": "text340",
  "Lastenjuhlat": "text341",
  "Lounge": "text342",
  "Opiskelijabileet": "text343",
  "Palvelutalo": "text344",
  "Päivätanssit": "text345",
  "Pikkujoulut": "text346",
  "Polttarit": "text347",
  "Pubi": "text348",
  "Ravintola": "text349",
  "Risteily": "text350",
  "Syntymäpäivät": "text351",
  "Tapahtuma": "text352",
  "Terassikeikka": "text353",
  "Tanssit": "text354",
  "Urheilutapahtuma": "text355",
  "Valmistujaiset": "text356",
  "Vuosijuhla": "text357",
  "Yksityisjuhlat": "text358",
  "Yritysjuhlat": "text359",
  "Yökerho": "text360"
};

export function translateAdminLabel(value) {
  const key = Object.prototype.hasOwnProperty.call(labelKeys, value)
    ? labelKeys[value]
    : null;
  return key ? i18n.t(key, { ns: "admin", defaultValue: value }) : value;
}
